import { render, staticRenderFns } from "./ProductDisplayModeToggle.vue?vue&type=template&id=20db089e"
import script from "./ProductDisplayModeToggle.vue?vue&type=script&lang=js"
export * from "./ProductDisplayModeToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports